module.exports = __webpack_public_path__ + "static/assets/aabe8577de12bc30a380db0555dce551.jpg";